document.addEventListener("DOMContentLoaded", function () {
  function isIE() {
    const ua = window.navigator.userAgent,
      msie = ua.indexOf("MSIE "),
      trident = ua.indexOf("Trident/");
    return msie > 0 || trident > 0;
  }
  if (!isIE()) {
    let setfoot2 = function () {
        (document.querySelector(".parent-sec").style.visibility = "visible"),
          (document.querySelector(".nyg-mask-box").style.visibility =
            "visible"),
          // appendItems2(foot_0_data, ".foot-0-box .foot-item-content", 0),
          appendItems2(foot_1_data, ".foot-1-box .foot-item-content", 1),
          // appendMobileItems2(foot_0_data, ".foot-0-box .foot-mobile-part", 0),
          appendMobileItems2(foot_1_data, ".foot-1-box .foot-mobile-part", 1),
          initSwiper2(),
          document.querySelectorAll(".foot-1-item").forEach((i) => {
            i.classList.add("show");
          }),
          document.querySelectorAll(".foot-item").forEach((item) => {
            item.addEventListener("click", function (e) {
              const index = item.dataset.index;
              (current_foot = parseInt(index) + 1),
                index == 0 &&
                  ((choose_data.foot_0 = item.dataset.type),
                  document
                    .querySelectorAll(".rodortrack")
                    .forEach((item) => (item.innerText = choose_data.foot_0)),
                  (document.querySelectorAll(".MTool-Stepcontent")[
                    index
                  ].innerText = item.dataset.name),
                  document
                    .querySelectorAll(".MTool-Step")
                    [index].classList.add("active"),
                  document.querySelectorAll(".foot-1-item").forEach((i) => {
                    i.classList.remove("show"),
                      i.dataset.matchHeader.includes(choose_data.foot_0) &&
                        i.classList.add("show");
                  }),
                  initSwiper2(),
                  changeMeasureImgs2()),
                index == 1 &&
                  ((choose_data.foot_1 = document.querySelector(
                    ".foot-1-item.active"
                  ).dataset.type),
                  (choose_data.foot_fullness = document
                    .querySelector(".foot-1-item.active")
                    .dataset.fullness.split(",")[0]),
                  (choose_data.name = document.querySelector(
                    ".foot-1-item.active"
                  ).dataset.name),
                  initClData2(),
                  (document.querySelectorAll(".MTool-Stepcontent")[
                    index
                  ].innerText = choose_data.name),
                  document
                    .querySelectorAll(".MTool-Step")
                    [index].classList.add("active"),
                  (choose_data.foot_0 = document.querySelector(
                    ".foot-1-item.active"
                  ).dataset.matchHeader),
                  document
                    .querySelectorAll(".foot-fullness-box .type-swatch-item")
                    .forEach((item) => {
                      item.classList.remove("active");
                      item.classList.remove("show");
                    }),
                  document
                    .querySelectorAll(".foot-fullness-box .type-swatch-item")
                    .forEach((item2) => {
                      if (
                        document
                          .querySelector(".foot-1-item.active")
                          .dataset.fullness.indexOf(item2.dataset.num) >= 0
                      ) {
                        item2.classList.add("show");
                      }
                    }),
                  document
                    .querySelector(
                      `.foot-fullness-box .type-swatch-item[data-num="${choose_data.foot_fullness}"]`
                    )
                    .classList.add("active"),
                  changeMeasureImgs2()),
                index == 2 &&
                  ((choose_data.foot_2 = item.dataset.type),
                  document
                    .querySelectorAll(".foot-2-item")
                    .forEach((element) => {
                      element.classList.remove("active");
                    }),
                  item.classList.add("active"),
                  document
                    .querySelectorAll(".foot-3-box .base-foot-box")
                    .forEach((i) => (i.style.display = "none")),
                  document
                    .querySelectorAll(`.foot-3-${choose_data.foot_2}-box`)
                    .forEach((i) => (i.style.display = "flex")),
                  document
                    .querySelectorAll(".foot-4-box .base-foot-box")
                    .forEach((i) => (i.style.display = "none")),
                  document
                    .querySelectorAll(`.foot-4-${choose_data.foot_2}-box`)
                    .forEach((i) => (i.style.display = "flex")),
                  (document.querySelectorAll(".MTool-Stepcontent")[
                    index
                  ].innerText = item.dataset.type),
                  document
                    .querySelectorAll(".MTool-Step")
                    [index].classList.add("active"),
                  setTimeout(function () {
                    document
                      .querySelector(`.foot-3-${choose_data.foot_2}-box input`)
                      .focus();
                  }, 1e3)),
                index == 5 &&
                  ((choose_data.foot_5 = document.querySelector(
                    ".foot-5-box .type-swatch-item.active"
                  ).dataset.type),
                  (choose_data.quantity =
                    document.querySelector(".type-swatch-item.active").dataset
                      .type === "Single"
                      ? 1
                      : 2),
                  (document.querySelector(".foot-6-item img").src =
                    foot_7_data.filter(
                      (items) =>
                        items.type == choose_data.foot_5 &&
                        items.num ==
                          document.querySelector(
                            ".foot-7-box .type-swatch-item.active"
                          ).dataset.num
                    )[0].src),
                  ((document.querySelector(
                    ".foot-fullness-box .foot-pc-part img"
                  ).src = document.querySelector(".foot-5-item img").src),
                  (document.querySelector(
                    `.foot-fullness-box .type-swatch-item[data-type="${choose_data.foot_fullness}"] img`
                  ).src = document.querySelector(".foot-5-item img").src)),
                  foot_cl_imgs
                    .filter((items) => items.header == choose_data.foot_1)
                    .forEach((items) => {
                      document.querySelector(
                        `.foot-fullness-box .type-swatch-item[data-type="${items.fullness}"] img`
                      ).src =
                        items[
                          `${choose_data.foot_5.toLowerCase()}${"Touch"}Src`
                        ];
                    }),
                  (document.querySelector(
                    '.foot-7-box .type-swatch-item[data-type="Above"] img'
                  ).src =
                    foot_7_data[choose_data.foot_5 == "Single" ? 0 : 3].src),
                  (document.querySelector(
                    '.foot-7-box .type-swatch-item[data-type="Touch"] img'
                  ).src =
                    foot_7_data[choose_data.foot_5 == "Single" ? 1 : 4].src),
                  (document.querySelector(
                    '.foot-7-box .type-swatch-item[data-type="Over"] img'
                  ).src =
                    foot_7_data[choose_data.foot_5 == "Single" ? 2 : 5].src),
                  (document.querySelectorAll(".MTool-Stepcontent")[
                    index
                  ].innerText =
                    choose_data.foot_5 == "Single" ? "1 Panel" : "2 Panels"),
                  document
                    .querySelectorAll(".MTool-Step")
                    [index].classList.add("active")),
                index == 6 &&
                  ((document.querySelectorAll(".MTool-Stepcontent")[
                    index
                  ].innerText = choose_data.foot_fullness),
                  document
                    .querySelectorAll(".MTool-Step")
                    [index].classList.add("active")),
                index == 7 &&
                  ((choose_data.foot_6 = document.querySelector(
                    ".foot-7-box .type-swatch-item.active"
                  ).dataset.num),
                  (choose_data.bottom = document.querySelector(
                    ".foot-7-box .type-swatch-item.active .title"
                  ).innerText),
                  (choose_data.bottom_type = document.querySelector(
                    ".foot-7-box .type-swatch-item.active"
                  ).dataset.type),
                  (document.querySelectorAll(".MTool-Stepcontent")[
                    index
                  ].innerText = choose_data.bottom),
                  document
                    .querySelectorAll(".MTool-Step")
                    [index].classList.add("active"),
                  getResult2()),
                ["0", "2", "5", "6"].includes(index) &&
                  (document
                    .querySelectorAll(`.foot-${index}-item`)
                    .forEach((element) => {
                      element.classList.remove("active");
                    }),
                  item.classList.add("active")),
                index != 8 &&
                  (document
                    .querySelectorAll(".foot-item-box")
                    .forEach((box) => box.classList.remove("show-item")),
                  document
                    .querySelector(`.foot-${current_foot}-box`)
                    .classList.add("show-item"),
                  (document.getElementById("return-btn").style.display =
                    current_foot > 1 ? "flex" : "none"),
                  (document.querySelectorAll(".MTool-line")[
                    index
                  ].style.border = "1px solid #652A0D"),
                  (document.querySelectorAll(".MTool-Step")[index].style.color =
                    "#652A0D"),
                  window.innerWidth < 769 &&
                    document.querySelector(".MTool-footer").scrollTo({
                      left: document.querySelectorAll(".MTool-Step")[index]
                        .offsetLeft,
                    }),
                  (choose_data.current_foot = current_foot),
                  setLocalMeasure2());
            });
          }),
          document.querySelectorAll(".MTool-Step").forEach(function (box) {
            box.addEventListener("click", function (e) {
              if (e.target.closest(".active")) {
                let index = e.target
                  .closest(".active")
                  .querySelector("span")
                  .innerText.trim();
                document
                  .querySelectorAll(".foot-item-box")
                  .forEach((box2) => box2.classList.remove("show-item")),
                  document
                    .querySelector(`.foot-${index}-box`)
                    .classList.add("show-item");
                let returnBtn = document.getElementById("return-btn");
                returnBtn &&
                  (returnBtn.style.display = index > 1 ? "flex" : "none");
              }
            });
          }),
          document
            .querySelectorAll(".nyg-mask-content-box input")
            .forEach((item) => {
              item.addEventListener("input", function (event) {
                item.parentNode.nextElementSibling
                  ? (item.parentNode.nextElementSibling.disabled = !(
                      item.value > 0
                    ))
                  : item.parentNode.parentNode.nextElementSibling &&
                    (item.parentNode.parentNode.nextElementSibling.disabled = !(
                      item.value > 0
                    ));
              });
            });
        const ids = [
          "yes-width",
          "no-width-2",
          "yes-height",
          "no-height-2",
          "no-width-1",
          "no-height-1",
        ];
        for (let i = 0; i < ids.length; i++)
          document
            .getElementById(ids[i])
            .addEventListener("submit", function (e) {
              e.preventDefault(), i < 4 ? inputNext(e) : inputNext2(e);
            });
        function inputNext(e) {
          let index = e.target.getAttribute("data-index");
          (current_foot = parseInt(index) + 1),
            index == 3 &&
              (choose_data.foot_2 == "No"
                ? ((choose_data.width =
                    Number(choose_data.width_input_1) +
                    Number(document.getElementById("width_input_2").value) +
                    Number(document.getElementById("width_input_3").value)),
                  (choose_data.width_input_2 = Number(
                    document.getElementById("width_input_2").value
                  )),
                  (choose_data.width_input_3 = Number(
                    document.getElementById("width_input_3").value
                  )))
                : (choose_data.width =
                    document.getElementById("width_input").value),
              (document.querySelectorAll(".MTool-Stepcontent")[
                index
              ].innerText = choose_data.width + `''`),
              document
                .querySelectorAll(".MTool-Step")
                [index].classList.add("active"),
              setTimeout(function () {
                document
                  .querySelector(`.foot-4-${choose_data.foot_2}-box input`)
                  .focus();
              }, 1e3)),
            index == 4 &&
              (choose_data.foot_2 == "No"
                ? ((choose_data.height =
                    Number(choose_data.height_input_1) +
                    Number(document.getElementById("height_input_2").value)),
                  (choose_data.height_input_2 = Number(
                    document.getElementById("height_input_2").value
                  )))
                : (choose_data.height =
                    document.getElementById("height_input").value),
              (document.querySelectorAll(".MTool-Stepcontent")[
                index
              ].innerText = choose_data.height + `''`),
              document
                .querySelectorAll(".MTool-Step")
                [index].classList.add("active")),
            document.querySelectorAll(".foot-item-box").forEach(function (box) {
              box.classList.remove("show-item");
            }),
            (document.querySelectorAll(".MTool-line")[index - 1].style.border =
              "1px solid #652A0D"),
            (document.querySelectorAll(".MTool-Step")[index - 1].style.color =
              "#652A0D");
          let currentBox = document.querySelector(`.foot-${current_foot}-box`);
          currentBox && currentBox.classList.add("show-item");
          let returnBtn = document.getElementById("return-btn");
          returnBtn && (returnBtn.style.display = index > 1 ? "flex" : "none"),
            (choose_data.current_foot = current_foot),
            setLocalMeasure2();
        }
        function inputNext2(e) {
          let index = e.target.getAttribute("data-index");
          (current_foot = parseInt(index) + 1),
            index == 3 &&
              ((choose_data.width_input_1 =
                document.getElementById("width_input_1").value),
              document
                .querySelectorAll(".foot-3-box .base-foot-box")
                .forEach((i) => (i.style.display = "none")),
              document
                .querySelectorAll(".foot-3-No-box-2")
                .forEach((i) => (i.style.display = "flex"))),
            index == 4 &&
              (document
                .querySelectorAll(".foot-4-box .base-foot-box")
                .forEach((i) => (i.style.display = "none")),
              document
                .querySelectorAll(".foot-4-No-box-2")
                .forEach((i) => (i.style.display = "flex")),
              (choose_data.height_input_1 =
                document.getElementById("height_input_1").value)),
            (choose_data.current_foot = current_foot),
            setLocalMeasure2();
        }
        document
          .querySelector(".nyg-mask-inner-box .icon-close")
          .addEventListener("click", function () {
            if (window.location.href.indexOf("measurement-tool") > 0) {
              window.location.href = "https://freshinelife.com/";
            }
          }),
          document
            .getElementById("return-btn")
            .addEventListener("click", function () {
              choose_data.current_foot--,
                (current_foot = choose_data.current_foot),
                document
                  .querySelectorAll(".foot-item-box")
                  .forEach((box) => box.classList.remove("show-item")),
                document
                  .querySelector(`.foot-${current_foot}-box`)
                  .classList.add("show-item"),
                current_foot == 1 &&
                  (document.getElementById("return-btn").style.display =
                    "none");
            }),
          document.querySelectorAll(".foot-1-item").forEach((item) => {
            item.addEventListener("click", function () {
              document
                .querySelectorAll(`.foot-1-box .foot-1-item`)
                .forEach((item2) => {
                  item2.classList.remove("active");
                }),
                item.classList.add("active");
              document
                .querySelectorAll(".foot-1-box .submit-btn")
                .forEach((items) => {
                  items.disabled = false;
                });
            });
          }),
          document.querySelectorAll(".type-swatch-item").forEach((item) => {
            item.addEventListener("click", function () {
              let i = item.dataset.index;
              if (i == 6) {
                choose_data.foot_fullness = item.dataset.num;
                initClData2();

                document.querySelector(
                  '.foot-7-box .type-swatch-item[data-type="Above"] img'
                ).src = foot_7_data[choose_data.foot_5 == "Single" ? 0 : 3].src;
                document.querySelector(
                  '.foot-7-box .type-swatch-item[data-type="Touch"] img'
                ).src = foot_7_data[choose_data.foot_5 == "Single" ? 1 : 4].src;
                document.querySelector(
                  '.foot-7-box .type-swatch-item[data-type="Over"] img'
                ).src = foot_7_data[choose_data.foot_5 == "Single" ? 2 : 5].src;
                document.querySelector(
                  ".foot-fullness-box .foot-pc-part img"
                ).src = document.querySelector(
                  `.foot-7-box .type-swatch-item.active img`
                ).src;
              }

              i == 5 &&
                ((choose_data.foot_5 = item.dataset.type),
                (choose_data.quantity = item.dataset.type === "Single" ? 1 : 2),
                (document.querySelector(".foot-5-item img").src =
                  foot_5_data.filter(
                    (item2) => item2.type == choose_data.foot_5
                  )[0].src));
              if (i == 7) {
                choose_data.foot_6 = item.dataset.num;
                choose_data.bottom_type = item.dataset.type;
                choose_data.foot_6_name =
                  item.querySelector(".title").innerText;
                const targetImg = document.querySelector(".foot-6-item img");
                targetImg.parentElement.classList.add("loading");
                const newImgData = foot_7_data.filter(
                    (items) =>
                      items.type == choose_data.foot_5 &&
                      items.num == item.dataset.num
                  )[0],
                  loaderImg = new Image();
                (loaderImg.src = newImgData.src),
                  (document.querySelector(
                    ".foot-fullness-box .foot-pc-part img"
                  ).src = newImgData.src);
                (loaderImg.onload = function () {
                  (targetImg.src = newImgData.src),
                    targetImg.parentElement.classList.remove("loading");
                }),
                  (loaderImg.onerror = function () {
                    targetImg.parentElement.classList.remove("loading");
                  });
              }
              document
                .querySelectorAll(`.foot-${i}-box .type-swatch-item`)
                .forEach((item2) => {
                  item2.classList.remove("active");
                }),
                item.classList.add("active");
            });
          });
      },
      changeMeasureImgs2 = function () {
        [
          {
            target:
              ".foot-2-box .foot-pc-part .foot-2-item[data-type='Yes'] img",
            key: "yes",
          },
          {
            target:
              ".foot-2-box .foot-mobile-part .foot-2-item[data-type='Yes'] img",
            key: "yesMb",
          },
          {
            target: ".foot-3-box .foot-2-box-a1 .foot-pc-part img",
            key: "yesWidthSrc",
          },
          {
            target: ".foot-3-box .foot-2-box-b1 .foot-pc-part img",
            key: "noWidthSrc1",
          },
          {
            target: ".foot-3-box .foot-2-box-b2 .foot-pc-part img",
            key: "noWidthSrc2",
          },
          {
            target: ".foot-3-box .foot-2-box-b2 .foot-mobile-part img",
            key: "noWidthMbSrc2",
          },
          {
            target: ".foot-4-box .foot-4-Yes-box .foot-pc-part img",
            key: "yesHeightSrc",
          },
          {
            target: ".foot-4-box .foot-4-No-box .foot-pc-part img",
            key: "noHeightSrc1",
          },
          {
            target: ".foot-4-box .foot-4-No-box-2 .foot-pc-part img",
            key: "noHeightSrc2",
          },
          {
            target: ".foot-4-box .foot-4-No-box-2 .foot-mobile-part img",
            key: "noHeightMbSrc2",
          },
          {
            target: ".foot-3-box .foot-mobile-part img",
            key: "yesWidthMbSrc",
          },
          {
            target: ".foot-4-box .foot-mobile-part img",
            key: "yesHeightMbSrc",
          },
        ].forEach((item) => {
          document.querySelector(item.target).src =
            foot_measure_imgs[choose_data.foot_0][item.key];
        });
      },
      initClData2 = function () {
        let cl_data = foot_cl_imgs.filter(
          (item) =>
            item.header == choose_data.foot_1 &&
            choose_data.foot_fullness == item.fullness
        )[0];
        if (cl_data) {
          (foot_5_data[0].src = cl_data.singleTouchSrc),
            (foot_5_data[1].src = cl_data.splitTouchSrc),
            (foot_7_data[0].src = cl_data.singleAboveSrc),
            (foot_7_data[1].src = cl_data.singleTouchSrc),
            (foot_7_data[2].src = cl_data.singleOverSrc),
            (foot_7_data[3].src = cl_data.splitAboveSrc),
            (foot_7_data[4].src = cl_data.splitTouchSrc),
            (foot_7_data[5].src = cl_data.splitOverSrc),
            (document.querySelector(
              '.foot-5-box .type-swatch-item[data-type="Split"] img'
            ).src = foot_7_data[4].src),
            (document.querySelector(
              '.foot-5-box .type-swatch-item[data-type="Single"] img'
            ).src = foot_7_data[1].src),
            (document.querySelector(".foot-5-box .foot-pc-part img").src =
              foot_5_data[choose_data.foot_5 == "Single" ? 0 : 1].src);
          document.querySelector(".foot-7-box .foot-pc-part img").src =
            cl_data[
              `${choose_data.foot_5.toLowerCase()}${
                document.querySelector(".foot-7-box .type-swatch-item.active")
                  .dataset.type
              }Src`
            ];
          let f6i = 4;
          choose_data.foot_5 == "Single"
            ? choose_data.bottom == "1'' Above Floor"
              ? (f6i = 0)
              : choose_data.bottom == "2'' Puddle On Floor"
              ? (f6i = 2)
              : (f6i = 1)
            : choose_data.bottom == "1'' Above Floor"
            ? (f6i = 3)
            : choose_data.bottom == "2'' Puddle On Floor" && (f6i = 5);
        }
      },
      appendItems2 = function (data, containerSelector, stepIndex) {
        const container = document.querySelector(containerSelector);
        data.forEach((v, i) => {
          const itemEl = document.createElement("div"),
            mobileItemEl = document.createElement("div");
          (itemEl.className = `foot-${stepIndex}-item foot-${stepIndex}-item-${
            v.type
          } item flex flex-column justify-content-center align-center gap-40 pointer show${
            stepIndex == 1 ? " swiper-slide" : ""
          } ${i == 0 ? "active" : ""}`),
            (itemEl.dataset.index = stepIndex),
            (itemEl.dataset.name = v.name),
            (itemEl.dataset.type = v.type),
            (itemEl.dataset.num = v.num),
            stepIndex == 1 &&
              ((itemEl.dataset.matchHeader = v.matchHeader.join(",")),
              (itemEl.dataset.fullness = v.fullness.join(","))),
            (itemEl.innerHTML = `
<img loading="lazy" src="${
              v.src
            }" style="z-index:2;position:relative" class="cl2">
                  <div class="name">${v.name}</div>
                  ${
                    stepIndex == 1 || stepIndex == 0
                      ? `
                  <div class="desc">${v.desc}</div>
                  `
                      : ""
                  }
              `),
            container.appendChild(itemEl);
        });
      },
      appendMobileItems2 = function (data, containerSelector, stepIndex) {
        const container = document.querySelector(containerSelector);
        data.forEach((v, i) => {
          const itemEl = document.createElement("div"),
            mobileItemEl = document.createElement("div");
          (itemEl.className = `foot-${stepIndex}-item foot-${stepIndex}-item-${
            v.type
          } item flex flex-row justify-content-center align-center gap-20 overflow-hidden show ${
            i == 0 ? "active" : ""
          }`),
            (itemEl.dataset.index = stepIndex),
            (itemEl.dataset.name = v.name),
            (itemEl.dataset.type = v.type),
            (itemEl.dataset.num = v.num),
            stepIndex == 1 &&
              (itemEl.dataset.matchHeader = v.matchHeader.join(",")),
            (itemEl.dataset.fullness = v.fullness.join(",")),
            (itemEl.innerHTML = `
<img loading="lazy" src="${v.src}" style="z-index:2;position:relative">
          <div class="text-container flex flex-column h-full">
                  <div class="name m-0">${v.name}</div>
                  ${
                    stepIndex == 1 || stepIndex == 0
                      ? `
                  <div class="desc overflow-hidden">${v.desc}</div>
                  `
                      : ""
                  }</div>
              `),
            container.appendChild(itemEl);
        });
      },
      getResult2 = function () {
        let appearance = choose_data.foot_5 === "Single" ? 1 : 2,
          choose_width =
            parseInt(choose_data.width) * parseFloat(choose_data.foot_fullness),
          choose_height = parseInt(choose_data.height),
          _height = parseFloat(choose_data.foot_6);
        (result.width = parseInt(choose_width / appearance)),
          (result.height = parseInt(choose_height + _height)),
          (result.qty = appearance),
          (result.name = choose_data.name),
          (document.querySelector(".shop-btn").dataset.value =
            JSON.stringify(result)),
          ["name", "foot_fullness", "bottom"].forEach((item, index) => {
            document.querySelectorAll(".foot-8-box .panel-box span")[
              index
            ].textContent = choose_data[item];
          }),
          (document.querySelectorAll(
            ".foot-8-box .panel-box span"
          )[3].textContent =
            choose_data.quantity == 1 ? "1 Panel" : "2 Panels"),
          (document.querySelector(".foot-8-box .foot-pc-part img").src =
            foot_7_data.filter(
              (item) =>
                item.type === choose_data.foot_5 &&
                item.num == choose_data.foot_6
            )[0].src),
          (document.querySelector(".foot-8-box .foot-img-container img").src =
            foot_7_data.filter(
              (item) =>
                item.type === choose_data.foot_5 &&
                item.num == choose_data.foot_6
            )[0].src),
          (document.querySelectorAll(
            ".foot-8-box .panel-box span"
          )[4].textContent = `${result.width}"W x ${result.height}"H`),
          (choose_data.r_width = result.width),
          (choose_data.r_height = result.height),
          (choose_data.r_qty = result.qty),
          setLocalMeasure2(),
          document
            .querySelector(".shop-btn")
            .addEventListener("click", function () {
              window.location.href.indexOf("measurement-tool") > 0
                ? (window.location.href =
                    "https://freshinelife.com/collections/custom-curtains")
                : (choose_data.room_name =
                    document.querySelector(".room-name-input").value ||
                    "baseRoom");
            }),
          document
            .querySelector(".foot-8-box .re-btn")
            .addEventListener("click", function () {
              document
                .querySelectorAll(".foot-item-box")
                .forEach((box) => box.classList.remove("show-item")),
                document
                  .querySelectorAll(".MTool-Step")
                  .forEach((box) => box.classList.remove("active")),
                document
                  .querySelectorAll(".MTool-Stepcontent")
                  .forEach((box) => (box.innerText = "")),
                document
                  .querySelector(".foot-1-box")
                  .classList.add("show-item"),
                document.querySelector(".MTool-Step").classList.add("active");
            });
      },
      calMeasurement2 = function (width, height, qty, name, type) {
        const widthSelect = document.querySelector(
            'select[name="Single Panel Width Before Pleats Made (inch)"]'
          ),
          heightSelect =
            document.querySelector(
              'select[name=Finished Length/Height (Inch)"]'
            ) ||
            document.querySelector(
              'select[name="Finished Length/Height (Inch)"]'
            ),
          nameInput = document.querySelector(
            `input[name="Header"][value="${name}"]`
          ),
          nameInput2 = document.querySelector(
            `input[key="po_Header"][value="${name}"]`
          ),
          qtyInput = document.querySelector('input[name="quantity"]');
        widthSelect && (widthSelect.value = width),
          heightSelect && (heightSelect.value = height),
          nameInput && (nameInput.checked = !0),
          nameInput2 && (nameInput2.checked = !0);
        function triggerChangeEvent(element) {
          if (element) {
            const event = new Event("change", {
              bubbles: !0,
              cancelable: !0,
            });
            element.dispatchEvent(event);
          }
        }
        setTimeout(() => {
          triggerChangeEvent(nameInput);
        }, 10),
          setTimeout(() => {
            triggerChangeEvent(nameInput2);
          }, 10),
          setTimeout(() => {
            triggerChangeEvent(widthSelect);
          }, 20),
          setTimeout(() => {
            heightSelect && triggerChangeEvent(heightSelect),
              qtyInput && (qtyInput.value = qty);
          }, 30),
          type === "load" &&
            setTimeout(() => {
              triggerChangeEvent(widthSelect);
            }, 4e3);
      },
      setLocalMeasure2 = function () {
        localStorage.setItem("baseRoom", JSON.stringify(choose_data));
      },
      getLocalMeasure2 = function () {
        return JSON.parse(localStorage.getItem("baseRoom"));
      },
      initStepLocal2 = function () {
        let localData = getLocalMeasure2();
        if (localData) {
          choose_data = localData;
          if (document.querySelector('input[key="po_Header"]:checked')) {
            choose_data.name = document.querySelector(
              'input[key="po_Header"]:checked'
            ).value;
          }
          for (let i = 1; i < localData.current_foot; i++) {
            initStepNext2(i, choose_data);
          }

          document
            .querySelectorAll(".foot-item-box")
            .forEach((box) => box.classList.remove("show-item")),
            document.querySelector(`.foot-1-box`).classList.add("show-item");
          document
            .querySelectorAll(".nyg-mask-content-box input")
            .forEach((item) => {
              item.parentNode.nextElementSibling
                ? (item.parentNode.nextElementSibling.disabled = !(
                    item.value > 0
                  ))
                : item.parentNode.parentNode.nextElementSibling &&
                  (item.parentNode.parentNode.nextElementSibling.disabled = !(
                    item.value > 0
                  ));
            });
        } else {
          if (document.querySelector('input[key="po_Header"]:checked')) {
            choose_data.name = document.querySelector(
              'input[key="po_Header"]:checked'
            ).value;
            initStepNext2(1, choose_data);
          }
        }
      },
      initStepNext2 = function (index, choose_data2) {
        index == 0 &&
          ((document.querySelectorAll(".MTool-Stepcontent")[index].innerText =
            choose_data2.foot_0),
          document
            .querySelectorAll(".rodortrack")
            .forEach((item) => (item.innerText = choose_data.foot_0)),
          document.querySelectorAll(".foot-1-item").forEach((i) => {
            i.classList.remove("show"),
              i.dataset.matchHeader.includes(choose_data2.foot_0) &&
                i.classList.add("show");
          })),
          index == 1 &&
            ((document.querySelectorAll(".MTool-Stepcontent")[index].innerText =
              choose_data2.name),
            document.querySelector(`.foot-pc-part .foot-1-item.active`) &&
              document
                .querySelector(`.foot-pc-part .foot-1-item.active`)
                .classList.remove("active"),
            document.querySelector(`.foot-mobile-part .foot-1-item.active`) &&
              document
                .querySelector(`.foot-mobile-part .foot-1-item.active`)
                .classList.remove("active"),
            document
              .querySelector(
                `.foot-pc-part .foot-1-item[data-name="${choose_data2.name}"]`
              )
              .classList.add("active"),
            document
              .querySelector(
                `.foot-mobile-part .foot-1-item[data-name="${choose_data2.name}"]`
              )
              .classList.add("active"),
            document
              .querySelector(".foot-1-box .swiper")
              .swiper.slideTo(
                foot_1_data.findIndex((item) => item.name == choose_data2.name)
              ),
            document
              .querySelectorAll(".foot-1-box .submit-btn")
              .forEach((items) => {
                items.disabled = false;
              }),
            initClData2(),
            changeMeasureImgs2()),
          index == 2 &&
            (document.querySelectorAll(".foot-2-item").forEach((element) => {
              element.classList.remove("active");
            }),
            document
              .querySelectorAll(".foot-3-box .base-foot-box")
              .forEach((i) => (i.style.display = "none")),
            document
              .querySelectorAll(`.foot-3-${choose_data2.foot_2}-box`)
              .forEach((i) => (i.style.display = "flex")),
            document
              .querySelectorAll(".foot-4-box .base-foot-box")
              .forEach((i) => (i.style.display = "none")),
            document
              .querySelectorAll(`.foot-4-${choose_data2.foot_2}-box`)
              .forEach((i) => (i.style.display = "flex")),
            (document.querySelectorAll(".MTool-Stepcontent")[index].innerText =
              choose_data2.foot_2)),
          index == 3 &&
            (choose_data2.foot_2 == "No"
              ? ((document.getElementById("width_input").value =
                  choose_data2.width),
                (document.getElementById("width_input_1").value =
                  choose_data2.width_input_1),
                (document.getElementById("width_input_2").value =
                  choose_data2.width_input_2))
              : ((document.getElementById("width_input").value =
                  choose_data2.width),
                document.getElementById("width_input"),
                showContinueBtn2(document.getElementById("width_input"))),
            (document.querySelectorAll(".MTool-Stepcontent")[index].innerText =
              choose_data2.width + `''`)),
          index == 4 &&
            (choose_data2.foot_2 == "No"
              ? ((choose_data2.height =
                  Number(choose_data2.height_input_1) +
                  Number(document.getElementById("height_input_2").value)),
                (document.getElementById("height_input_2").value =
                  choose_data2.height_input_2))
              : ((document.getElementById("height_input").value =
                  choose_data2.height),
                showContinueBtn2(document.getElementById("height_input"))),
            (document.querySelectorAll(".MTool-Stepcontent")[index].innerText =
              choose_data2.height + `''`)),
          index == 5 &&
            (document
              .querySelectorAll(".foot-5-box .type-swatch-item")
              .forEach((items) => items.classList.remove("active")),
            document
              .querySelector(
                `.foot-5-box .type-swatch-item[data-type="${choose_data2.foot_5}"]`
              )
              .classList.add("active"),
            (document.querySelector(".foot-5-item img").src =
              foot_5_data.filter(
                (item2) => item2.type == choose_data.foot_5
              )[0].src),
            (document.querySelector(".foot-6-item img").src =
              foot_7_data.filter(
                (items) =>
                  items.type == choose_data2.foot_5 &&
                  items.num ==
                    document.querySelector(
                      ".foot-7-box .type-swatch-item.active"
                    ).dataset.num
              )[0].src),
            (document.querySelector(".foot-6-item img").src =
              foot_7_data.filter(
                (items) =>
                  items.type == choose_data2.foot_5 &&
                  items.num ==
                    document.querySelector(
                      ".foot-7-box .type-swatch-item.active"
                    ).dataset.num
              )[0].src),
            (document.querySelectorAll(".MTool-Stepcontent")[index].innerText =
              choose_data2.quantity === 1 ? "1 Panel" : "2 Panels")),
          index == 6 &&
            ((document.querySelectorAll(".MTool-Stepcontent")[index].innerText =
              choose_data2.bottom),
            getResult2()),
          document
            .querySelectorAll(".MTool-Step")
            [index].classList.add("active"),
          (document.getElementById("return-btn").style.display =
            choose_data2.current_foot > 1 ? "flex" : "none");
      },
      showContinueBtn2 = function (target) {
        if (target.value > 0) {
          target.parentNode.nextElementSibling
            ? (target.parentNode.nextElementSibling.disabled = !1)
            : target.parentNode.parentNode.nextElementSibling &&
              (target.parentNode.parentNode.nextElementSibling.disabled = !1);
        }
      },
      initSwiper2 = function () {
        new Swiper(".foot-1-box .swiper", {
          slidesPerView: 3,
          spaceBetween: 10,
          slidesPerGroup: 3,
          slideToClickedSlide: !0,
          breakpoints: {
            1366: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 15,
            },
          },
          pagination: {
            el: ".foot-1-box .swiper-pagination",
            clickable: !0,
          },
          navigation: {
            nextEl: ".foot-1-box .swiper-button-next",
            prevEl: ".foot-1-box .swiper-button-prev",
          },
        });
      };
    var setfoot = setfoot2,
      changeMeasureImgs = changeMeasureImgs2,
      initClData = initClData2,
      appendItems = appendItems2,
      appendMobileItems = appendMobileItems2,
      getResult = getResult2,
      calMeasurement = calMeasurement2,
      setLocalMeasure = setLocalMeasure2,
      getLocalMeasure = getLocalMeasure2,
      initStepLocal = initStepLocal2,
      initStepNext = initStepNext2,
      showContinueBtn = showContinueBtn2,
      initSwiper = initSwiper2;
    let choose_data = {
        width: 0,
        width1: 0,
        width_input_2: 0,
        width_input_3: 0,
        height: 0,
        height_input_1: 0,
        bottom: 0,
        current_foot: 0,
        room_name: "baseRoom",
        foot_5: "Split",
        foot_6: "Touch",
        foot_6_name: "Touch the floor",
        foot_fullness: "2.0",
        bottom_type: "Touch",
      },
      current_foot = 2,
      result = {};
    const foot_measure_imgs = {
        Rod: {
          yesWidthSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-3-width-3.webp",
          yesWidthMbSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/mbmeasure-3-width-1-2.webp",
          noWidthSrc1:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-3-width-no-1-2.webp",
          noWidthSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-3-width-no-2-2.webp",
          noWidthMbSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-mb-rod-no-width-2.webp",
          yesHeightSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-4-height-6.webp",
          yesHeightMbSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/mbmeasure-4-height-1-2.webp",
          noHeightSrc1:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-4-height-no-1.webp",
          noHeightSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-4-height-no-2.webp",
          noHeightMbSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-mb-rod-no-height-2.webp",
          yes: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-have-4.webp",
          yesMb:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-mb-yes.webp",
        },
        Track: {
          yesWidthSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-measure-yes-width-1.webp",
          yesWidthMbSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-mbmeasure-yes-width-1.webp",
          noWidthSrc1:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-measure-no-width-1.webp",
          noWidthSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-measure-no-width-2-2.webp",
          noWidthMbSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-mb-track-no-width-2.webp",
          yesHeightSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-measure-yes-height-1.webp",
          yesHeightMbSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-mbmeasure-yes-height-1.webp",
          noHeightSrc1:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-measure-no-height-1.webp",
          noHeightSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-measure-no-height-2-2.webp",
          noHeightMbSrc2:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-mb-track-no-height-2.webp",
          yes: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/track-measure-yes.webp",
          yesMb:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-mb-track-yes.webp",
        },
      },
      foot_cl_imgs = [
        {
          header: "Rod-Grommet-Top",
          fullness: "2.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-2.0-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-2.0-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-2.0-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-2.0-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-2.0-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-2.0-Split-Over.webp",
        },
        {
          header: "Rod-Grommet-Top",
          fullness: "2.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Grommet_Top-2.5-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Grommet_Top-2.5-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Grommet_Top-2.5-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Grommet_Top-2.5-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Grommet_Top-2.5-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Grommet_Top-2.5-Split-Over.webp",
        },
        {
          header: "Rod-Grommet-Top",
          fullness: "1.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-1.5-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-1.5-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Grommet_Top-1.5-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-2-Grommet_Top-1.5-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-2-Grommet_Top-1.5-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-2-Grommet_Top-1.5-Split-Over.webp",
        },
        {
          header: "Rod-Pinch-Pleat-Double",
          fullness: "2.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Double-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Double-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Double-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Double-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Double-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Double-Split-Over.webp",
        },
        {
          header: "Rod-Pinch-Pleat-Triple",
          fullness: "2.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Triple-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Triple-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Triple-Single-Over-2.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Triple-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Triple-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Pinch-Pleat-Triple-Split-Over-2.webp",
        },
        {
          header: "Rod-Pocket",
          fullness: "1.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.0-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.0-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.0-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.0-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.0-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.0-Split-Over.webp",
        },
        {
          header: "Rod-Pocket",
          fullness: "1.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.5-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.5-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.5-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.5-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.5-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Rod-Pocket-1.5-Split-Over.webp",
        },
        {
          header: "Rod-Pocket",
          fullness: "2.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-2-Rod_Pocket-2.0-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-2-Rod_Pocket-2.0-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-2-Rod_Pocket-2.0-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-2-Rod_Pocket-2.0-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-2-Rod_Pocket-2.0-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-2-Rod_Pocket-2.0-Split-Over.webp",
        },
        {
          header: "Rod-Pocket",
          fullness: "2.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Rod_Pocket-2.5-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Rod_Pocket-2.5-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Rod_Pocket-2.5-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Rod_Pocket-2.5-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Rod_Pocket-2.5-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-716-Rod_Pocket-2.5-Split-Over.webp",
        },
        {
          header: "Rod-Euro-Pleat-Double",
          fullness: "2.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Double-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Double-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Double-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Double-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Double-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Double-Split-Over.webp",
        },
        {
          header: "Rod-Euro-Pleat-Triple",
          fullness: "2.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Triple-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Triple-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Triple-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Triple-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Triple-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Euro-Pleat-Triple-Split-Over.webp",
        },
        {
          header: "Rod-Flat-Panel",
          fullness: "1.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.0-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.0-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.0-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.0-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.0-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.0-Split-Over.webp",
        },
        {
          header: "Rod-Flat-Panel",
          fullness: "1.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.5-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.5-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.5-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.5-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.5-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-1.5-Split-Over.webp",
        },
        {
          header: "Rod-Flat-Panel",
          fullness: "2.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-2.0-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-2.0-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-2.0-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-2.0-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-2.0-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-715-Flat_Panel-2.0-Split-Over.webp",
        },
        {
          header: "Rod-Flat-Panel-Max",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Flat-Panel-2.0-Single-Above-2.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Flat-Panel-2.0-Single-Touch-2.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Flat-Panel-2.0-Single-Over-2.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Flat-Panel-2.0-Split-Above-2.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Flat-Panel-2.0-Split-Touch-2.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Rod-Flat-Panel-2.0-Split-Over-2.webp",
        },
        {
          header: "Track-tongtong",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Double-Single-Above-2.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Double-Single-Touch-2.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Double-Single-Over-2.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Double-Split-Above-2.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Double-Split-Touch-2.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Double-Split-Over-2.webp",
        },
        {
          header: "Track-Euro-Pleat-Triple",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Euro_Pleat-Triple-Single-Above-3.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Euro_Pleat-Triple-Single-Touch-3.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Euro_Pleat-Triple-Single-Over-3.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Triple-Split-Above-2.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Triple-Split-Touch-2.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Euro_Pleat-Triple-Split-Over-2.webp",
        },
        {
          header: "Track-Pinch-Pleat-Double",
          fullness: "2.0",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Double-Single-Above-2.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Double-Single-Touch-2.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Double-Single-Over-2.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Double-Split-Above-2.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Double-Split-Touch-2.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Double-Split-Over-2.webp",
        },
        {
          header: "Track-Pinch-Pleat-Triple",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Triple-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Triple-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Triple-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Triple-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Triple-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Pinch-Pleat-Triple-Split-Over.webp",
        },
        {
          header: "Track-Ripple-Fold",
          fullness: "2.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Ripple-Fold-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Ripple-Fold-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Ripple-Fold-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Ripple-Fold-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Ripple-Fold-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/Track-Ripple-Fold-Split-Over.webp",
        },
         {
          header: "Back-Tab",
          fullness: "2.5",
          singleAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-826-2-Back_Tab-2.5-Single-Above.webp",
          singleTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-826-2-Back_Tab-2.5-Single-Touch.webp",
          singleOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-826-2-Back_Tab-2.5-Single-Over.webp",
          splitAboveSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-826-2-Back_Tab-2.5-Split-Above.webp",
          splitTouchSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-826-2-Back_Tab-2.5-Split-Touch.webp",
          splitOverSrc:
            "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-826-2-Back_Tab-2.5-Split-Over.webp",
        },
      ],
      foot_0_data = [
        {
          name: "Rod",
          type: "Rod",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-0-Rod-1.webp",
          desc: "Classic look, easy to install, works with grommet or ring-top curtains.",
        },
        {
          name: "Track",
          type: "Track",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-0-Track-1.webp",
          desc: "Sleek style, space-saving, smooth glide for ceiling or layered setups.",
        },
      ],
      foot_1_data = [
        {
          name: "Pinch Pleat - Double",
          type: "Rod-Pinch-Pleat-Double",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Pinch_Pleat-Double-2.webp",
          matchHeader: ["Rod"],
          desc: "Tailored double pleats for a classic, structured drape.",
          fullness: ["2.0"],
        },

        {
          name: "Pinch Pleat - Triple",
          type: "Rod-Pinch-Pleat-Triple",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Pinch-Pleat-Triple-3.webp",
          matchHeader: ["Rod"],
          desc: "Triple pleats for rich volume and a formal, elegant look.",
          fullness: ["2.5"],
        },
        {
          name: "Rod Pocket",
          type: "Rod-Pocket",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Rod_Pocket-Standard-3.webp",
          matchHeader: ["Rod"],
          desc: "Classic rod pocket for a clean, casual look.",
          fullness: ["2.0", "1.0", "1.5", "2.5"],
        },
        {
          name: "Flat Panel",
          type: "Rod-Flat-Panel",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Flat_Panel-Standard-3.webp",
          matchHeader: ["Rod"],
          desc: "Sleek, flat design ideal for a tailored, minimalist finish.",
          fullness: ["2.0", "1.0", "1.5"],
        },
        {
          name: "Euro Pleat - Double",
          type: "Rod-Euro-Pleat-Double",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Euro_Pleat-Double-2.webp",
          matchHeader: ["Rod"],
          desc: "Modern double Euro pleats with clean, refined lines.",
          fullness: ["2.0"],
        },
        {
          name: "Euro Pleat - Triple",
          type: "Rod-Euro-Pleat-Triple",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Euro_Pleat-Triple-2.webp",
          matchHeader: ["Rod"],
          desc: "Triple Euro pleats for enhanced volume and a contemporary, upscale finish.",
          fullness: ["2.5"],
        },

        // {
        //   name: "Grommet Top - Max",
        //   type: "Rod-Grommet-Top-Max",
        //   src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Grommet_Top-MAX-2.webp",
        //   matchHeader: ["Rod"],
        //   desc: "Enhanced fullness for a richer, more dramatic drape.",
        // },

        // {
        //   name: "Rod Pocket Max",
        //   type: "Rod-Pocket-Max",
        //   src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Rod_Pocket-2.webp",
        //   matchHeader: ["Rod"],
        //   desc: "Added volume for a softly gathered, full appearance.",
        // },
        {
          name: "Grommet Top",
          type: "Rod-Grommet-Top",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Grommet_Top-Standard-2.webp",
          matchHeader: ["Rod"],
          desc: "Simple, modern header with soft natural folds.",
          fullness: ["2.0", "1.5", "2.5"],
        },
         {
          name: "Ripple Fold",
          type: "Track-Ripple-Fold",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Ripple_Fold-2.webp",
          matchHeader: ["Track"],
          desc: "Soft, continuous waves for a sleek, modern appearance.",
          fullness: ["2.5"],
        },
        
        {
          name: "Back Tab",
          type: "Back-Tab",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-header-Back-Tab-Triple.webp",
          matchHeader: ["Rod"],
          desc: "Fits standard curtain rods and can also be hung using rings or clips",
          fullness: ["2.5"],
        },
        // {
        //   name: "Flat Panel - Max",
        //   type: "Rod-Flat-Panel-Max",
        //   src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Rod-Flat_Panel-2.webp",
        //   matchHeader: ["Rod"],
        //   desc: "Extra fabric for a soft, elegant drape with more body.",
        // },

        // {
        //   name: "Euro Pleat - Double",
        //   type: "Track-Euro-Pleat-Double",
        //   src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Euro_Pleat-Double-2.webp",
        //   matchHeader: ["Track"],
        //   desc: "Modern double Euro pleats with clean, refined lines.",
        // },

        // {
        //   name: "Euro Pleat - Triple",
        //   type: "Track-Euro-Pleat-Triple",
        //   src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Euro_Pleat-Triple-2.webp",
        //   matchHeader: ["Track"],
        //   desc: "Triple Euro pleats for enhanced volume and a contemporary, upscale finish.",
        // },
        // {
        //   name: "Pinch Pleat - Double",
        //   type: "Track-Pinch-Pleat-Double",
        //   src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Pinch_Pleat-Double-3.webp",
        //   matchHeader: ["Track"],
        //   desc: "Tailored double pleats for a classic, structured drape.",
        // },
        // {
        //   name: "Pinch Pleat - Triple",
        //   type: "Track-Pinch-Pleat-Triple",
        //   src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-Track-Pinch_Pleat-Triple-2.webp",
        //   matchHeader: ["Track"],
        //   desc: "Triple pleats for rich volume and a formal, elegant look.",
        // },
      ],
      foot_5_data = [
        {
          name: "Single",
          type: "Single",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-5-single_panel.webp",
        },
        {
          name: "Split",
          type: "Split",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-5-split_panel.webp",
        },
      ],
      foot_6_data = [
        {
          name: "1.5x Fullness",
          num: "1.5",
          type: "single",
          note: `Minimal folds
                     Light/Gentle pleats`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-153.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-15.webp",
          matchHeader: ["Rod Pocket", "Flat Panel"],
        },
        {
          name: "1.5x Fullness",
          num: "1.5",
          type: "single",
          note: `Minimal folds
                     Light/Gentle pleats`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-153.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-15.webp",
          matchHeader: ["Grommet Top", "Rod Pocket", "Flat Panel"],
        },
        {
          name: "2.0x Fullness",
          num: "2.0",
          type: "single",
          note: `Standard folds
                    Ideal/Elegant pleats`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-203.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-20.webp",
          matchHeader: [
            "Grommet Top",
            "Pinch Pleat - Double",
            "Rod Pocket",
            "Euro Pleat - Double",
            "Flat Panel",
          ],
        },
        {
          name: "2.5x Fullness",
          num: "2.5",
          type: "single",
          note: `Maximun folds
                     Luxe/Rich pleats`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-253.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-35.webp",
          matchHeader: [
            "Pinch Pleat - Triple",
            "Ripple Fold",
            "Euro Pleat - Triple",
            "Grommet Top",
            "Rod Pocket",
            "Back Tab"
          ],
        },
        {
          name: "1.0x Fullness",
          num: "1.0",
          type: "single",
          note: `Minimum choice`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-153.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-15.webp",
          matchHeader: ["Rod Pocket", "Flat Panel"],
        },
        {
          name: "1.5x Fullness",
          num: "1.5",
          type: "split",
          note: `Minimal folds
                     Light/Gentle pleats`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-1.53.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-mobile-15.webp",
          matchHeader: ["Flat Panel"],
        },
        {
          name: "2.0x Fullness",
          num: "2.0",
          type: "split",
          note: `Standard folds
                    Ideal/Elegant pleats`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-23.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-mobile-20.webp",
          matchHeader: [
            "Grommet Top",
            "Pinch Pleat - Double",
            "Rod Pocket",
            "Euro Pleat - Double",
            "Flat Panel",
          ],
        },
        {
          name: "2.5x Fullness",
          num: "2.5",
          type: "split",
          note: `Maximun folds
                    Luxe/Rich pleats`,
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-253.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-mobile-25.webp",
          matchHeader: [
            "Pinch Pleat - Triple",
            "Ripple Fold",
            "Euro Pleat - Triple",
            "Rod Pocket",
            "Back Tab"
          ],
        },
      ],
      foot_7_data = [
        {
          name: "1'' Above Floor",
          num: "-1",
          type: "Single",
          note: "",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-7-single-above.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-in.webp",
        },
        {
          name: "Touch the floor",
          num: "0",
          type: "Single",
          note: "",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-7-single-touch.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-normal.webp",
        },
        {
          name: "2'' Puddle On Floor",
          num: "2",
          type: "Single",
          note: "",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-7-single-over.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/single-mobile-over.webp",
        },
        {
          name: "1'' Above Floor",
          num: "-1",
          type: "Split",
          note: "",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-7-split-above.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-mobile-in.webp",
        },
        {
          name: "Touch the floor",
          num: "0",
          type: "Split",
          note: "",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-7-split-touch.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-mobile-normal.webp",
        },
        {
          name: "2'' Puddle On Floor",
          num: "2",
          type: "Split",
          note: "",
          src: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-7-split-over.webp",
          srcM: "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/split-mobile-over.webp",
        },
      ];
    setfoot2(), initStepLocal2();
    return;
  }
});
